import { useWorkspace } from "../../app/workspace";
import { PageHeader } from "../../components/ui/Page";
import { MembersCard } from "./MembersCard";
import { ProfileCard } from "./ProfileCard";

export function SettingsPage() {
  const { workspace } = useWorkspace();
  return (
    <>
      <PageHeader caption={`workspace: ${workspace.name.toLowerCase()} · you are ${workspace.role}`} title="Settings" />
      <ProfileCard />
      <MembersCard />
    </>
  );
}
